import { loadLanguageAsync, defaultLang } from '$locales/index.js'

const i18n = {
  namespaced: true,
  state: {
    lang: defaultLang
  },
  mutations: {
    SET_LANG: (state, lang) => {
      state.lang = lang
    }
  },
  actions: {
    // 设置界面语言
    SetLang ({ commit }, lang) {
      window.localStorage.setItem('noCodeLang', lang)
      return new Promise(resolve => {
        commit('SET_LANG', lang)
        loadLanguageAsync(lang)
        resolve()
      })
    }
  }
}

export default i18n
